import React, { useEffect } from "react";
import loadable from "@loadable/component";
import styles from "./styles.css";
import PropTypes from "prop-types";
import FranchiseHomeBanner from "../franchise-home-banner";
import FranchiseWhyCars from "../../shared/franchise-why-cars";
import FranchiseDownloadBrochure from "../../shared/franchise-download-brochure";
import InfoIcon from "./images/info.svg";
import BreadcrumbList from "../../shared/breadcrumb-list";
import { appUrl } from "../../../constants/url-constants";
import FranchiseFaqs from "../franchise-faqs";
import { sendCustomGaEvents } from "../../../tracking";
import { landingPageEvent } from "../../../constants/tracking-constants/franchise-ga";
import FranchiseMetaTags from "../../shared/franchise-meta-tags";
import { LazyComponent } from "../../shared/lazy-image";
import { NUMBER } from "../../../constants/app-constants";
import FranchiseInfo from "../franchise-info";

const FranchiseEarningChart = loadable(() => import("../../shared/franchise-earning-chart"));
const FranchiseJourneyBecomeOwner = loadable(() => import("../franchise-journey-become-owner"));
const FranchiseTestimonials = loadable(() => import("../franchise-testimonials"));

const Franchise = ({
    genericContent,
    updateSSRStatusConnect,
    setIsSSRConnect,
    testimonials,
    fetchTestimonialsConnect,
    isSSR
}) => {

    useEffect(() => {
        if (!isSSR && testimonials.length === NUMBER.ZERO) {
            fetchTestimonialsConnect("franchise");
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isSSR, testimonials]);

    useEffect(() => {
        updateSSRStatusConnect();
        setIsSSRConnect(false);
        sendCustomGaEvents(landingPageEvent);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { content = "" } = genericContent || {};

    const onBreadcrumbClick = ({ item }) => {
        if (item === "home") {
            window.location.href = `${appUrl()}/sell-used-cars/`;
        } else {
            window.location.href = `${appUrl()}${item.redirectURL}/`;
        }
    };

    const computeBreadcrumbList = () => {
        return [{ displayText: "CARS24 Franchise" }];
    };

    return (
        <React.Fragment>
            <FranchiseMetaTags />
            <FranchiseHomeBanner />
            <div styleName={"styles.wrapper"}>
                {content &&
                    <FranchiseInfo
                        title="What is CARS24 franchise?"
                        description={content}
                    />
                }
                <div styleName={"styles.whyCarsWrapper"}>
                    <FranchiseWhyCars />
                </div>

                <div styleName={"styles.brochureWrapper"}>
                    <LazyComponent>
                        <div styleName={"styles.franchiseDownloadBrochure"}>
                            <div>
                                <img src={InfoIcon} alt={"info"} height={56} width={52} />
                                <span>Find out all the information you need about CARS24 Franchise here.</span>
                            </div>
                            <FranchiseDownloadBrochure />
                        </div>
                    </LazyComponent>
                </div>
                <div styleName={"styles.earningChartWrapper"} >
                    <LazyComponent>
                        <FranchiseEarningChart />
                    </LazyComponent>
                </div>

                {!!(testimonials && testimonials.length > NUMBER.ZERO) &&
                    <div styleName={"styles.testimonialsWrapper"}>
                        <LazyComponent>
                            <FranchiseTestimonials
                                title="Hear from our partners"
                            />
                        </LazyComponent>
                    </div>
                }

                <FranchiseJourneyBecomeOwner />

            </div>
            <FranchiseFaqs />
            <div styleName={"styles.breadcrumbList"}>
                <BreadcrumbList
                    homeText={"Home"}
                    onClickCallback={onBreadcrumbClick}
                    list={computeBreadcrumbList()}
                    isRevamped={true}
                    attachSchema={true}
                />
            </div>
        </React.Fragment >
    );
};

Franchise.propTypes = {
    genericContent: PropTypes.object,
    history: PropTypes.object,
    updateSSRStatusConnect: PropTypes.func,
    setIsSSRConnect: PropTypes.func,
    fetchTestimonialsConnect: PropTypes.func,
    isSSR: PropTypes.bool,
    testimonials: PropTypes.array
};

export default Franchise;
